import { render, staticRenderFns } from "./WorkshopEditDialog.vue?vue&type=template&id=65ae0ecd&scoped=true"
import script from "./WorkshopEditDialog.vue?vue&type=script&lang=js"
export * from "./WorkshopEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ae0ecd",
  null
  
)

export default component.exports